import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { AiBotConfigState, SLICE_NAME } from './models';

const aiBotConfigSelector = (state: RootState): AiBotConfigState => state[SLICE_NAME];

export const selectAiBotSettings = createSelector(aiBotConfigSelector, (state: AiBotConfigState) => state.settings);

export const selectAiBotSettingsIsLoading = createSelector(
  aiBotConfigSelector,
  (state: AiBotConfigState) => state.isLoading,
);

export const selectAiBotSettingsError = createSelector(aiBotConfigSelector, (state: AiBotConfigState) => state.error);
